<template>
    <div>
        <span v-if="expandido">
            {{texto}}
            <a class="link-expandir" v-if="exibirLink(texto)"
               @click="expandido = false">Mostrar menos</a>
        </span>
        <span v-else>
            {{ texto | az-clip-text(tamanho)}}
            <a class="link-expandir" v-if="exibirLink(texto)"
               @click="expandido = true">Continuar lendo</a>
        </span>
    </div>
</template>

<script>
    export default {
        props: ['texto', 'tamanho'],
        data() {
            return {
                expandido: false
            }
        },
        methods: {
            exibirLink(texto) {
                return texto && texto.length > this.tamanho
            }
        }
    }
</script>
<style scoped lang="stylus">
    .link-expandir
        color #555
        text-align end
        display block
        margin 5px 10px 0 0
</style>